import { useEffect, useState } from 'react';
import { handleData } from '../../api';
import '../../css/adminStyling.css';
import AdminActiviteit from './AdminActiviteit';
import AdminActiviteitFull from './AdminActiviteitFull';
import AdminNewOrEditActiviteit from './AdminNewOrEditActiviteit';

import { useAdminActiviteiten } from '../../utils/adminActiviteiten';

const AdminActiviteiten = () => {

    const act = useAdminActiviteiten();

    const [future, setFuture] = useState(true);
    const [selectedActiviteit, setSelectedActiviteit] = useState('');
    const [addNewActiviteit, setAddNewActiviteit] = useState(false);

    const activiteiten = act.adminFutureActiviteiten;
    const pastActiviteiten = act.adminPastActiviteiten;

    const handleNewActiviteit = () => {
        setAddNewActiviteit(true);
    }

    const closeActiviteitForm = (hasNewAdded) => {
        if (hasNewAdded) {
            act.loadAdminActiviteiten();
        }
        setAddNewActiviteit(false);
    }

    const deleteActiviteit = async (id) => {
        const path = `activiteiten/verwijder/${id}`
        const data = {
            method: 'DELETE',
            path: path
        }
        const result = await handleData(data);
        if (result.data.success) {
            setSelectedActiviteit('');
            act.loadActiviteiten();
        }
    }

    const toggleFutureOrPast = () => {
        setFuture(!future);
        setSelectedActiviteit('');
    }

    useEffect(() => {
        act.loadAdminActiviteiten();
    },[]);

    return (
        <>
            <h2>Admin - Activiteiten</h2>
            <br />
            <div className="adminActiviteitenContainer">
                <div className="aankomend">
                    <div className='newActiviteit'>
                        <button onClick={handleNewActiviteit}>Voeg nieuwe activiteit toe</button>
                        {addNewActiviteit && <AdminNewOrEditActiviteit 
                            closeActiviteitForm={closeActiviteitForm}  
                            mode="new"/>}

                    </div>
                    <br />
                    <h3>Overzicht {future ? "toekomstige" : "afgelopen"} activiteiten</h3>
                    <button onClick = {toggleFutureOrPast}>{future ? "Afgelopen Activiteiten" : "Toekomstige Activiteiten"}</button>
                    <table>
                        <tbody className="adminActListTBody">
                            {future && activiteiten.map((item) => <AdminActiviteit 
                                activiteit={item}
                                selectedActiviteit = {selectedActiviteit} 
                                setSelectedActiviteit = {setSelectedActiviteit}
                                key= {item._id}/>)}
                            {!future && pastActiviteiten.map((item) => <AdminActiviteit 
                                activiteit={item}
                                selectedActiviteit = {selectedActiviteit} 
                                setSelectedActiviteit = {setSelectedActiviteit}
                                key= {item._id}/>)}

                        </tbody>
                    </table>
                </div>
                <div className="full">
                    {future && selectedActiviteit && <AdminActiviteitFull 
                        activiteit={activiteiten.find(item => item._id === selectedActiviteit)}
                        deleteActiviteit = {deleteActiviteit}
                        closeActiviteitForm = {closeActiviteitForm}
                        setSelectedActiviteit = {setSelectedActiviteit} 
                    />}
                    {!future && selectedActiviteit && <AdminActiviteitFull 
                        activiteit={pastActiviteiten.find(item => item._id === selectedActiviteit)}
                        deleteActiviteit = {deleteActiviteit}
                        closeActiviteitForm = {closeActiviteitForm}
                        setSelectedActiviteit = {setSelectedActiviteit}
                    />}
                </div>
            </div>
        </>
    );
}

export default AdminActiviteiten;